function Unite(nombre) {
    let unite;
    switch (nombre) {
        case 0: unite = "zéro"; break;
        case 1: unite = "un"; break;
        case 2: unite = "deux"; break;
        case 3: unite = "trois"; break;
        case 4: unite = "quatre"; break;
        case 5: unite = "cinq"; break;
        case 6: unite = "six"; break;
        case 7: unite = "sept"; break;
        case 8: unite = "huit"; break;
        case 9: unite = "neuf"; break;
    }
    return unite;
}

function Dizaine(nombre) {
    let dizaine;
    switch (nombre) {
        case 10: dizaine = "dix"; break;
        case 11: dizaine = "onze"; break;
        case 12: dizaine = "douze"; break;
        case 13: dizaine = "treize"; break;
        case 14: dizaine = "quatorze"; break;
        case 15: dizaine = "quinze"; break;
        case 16: dizaine = "seize"; break;
        case 17: dizaine = "dix-sept"; break;
        case 18: dizaine = "dix-huit"; break;
        case 19: dizaine = "dix-neuf"; break;
        case 20: dizaine = "vingt"; break;
        case 30: dizaine = "trente"; break;
        case 40: dizaine = "quarante"; break;
        case 50: dizaine = "cinquante"; break;
        case 60: dizaine = "soixante"; break;
        case 70: dizaine = "soixante-dix"; break;
        case 80: dizaine = "quatre-vingt"; break;
        case 90: dizaine = "quatre-vingt-dix"; break;
    }
    return dizaine;
}

function NumberToLetter(nombre) {
    let quotient, reste, nb;
    let numberToLetter = "";

    if (nombre.toString().replace(/ /gi, "").length > 15)
        return "dépassement de capacité";

    if (isNaN(nombre.toString().replace(/ /gi, "")))
        return "Nombre non valide";

    nb = parseFloat(nombre.toString().replace(/ /gi, ""));

    if (Math.ceil(nb) !== nb)
        return "Nombre avec virgule non géré.";

    const n = nb.toString().length;

    switch (n) {
        case 1:
            numberToLetter = Unite(nb);
            break;

        case 2:
            if (nb > 19) {
                quotient = Math.floor(nb / 10);
                reste = nb % 10;

                if (nb < 71 || (nb > 79 && nb < 91)) {
                    if (reste === 0) numberToLetter = Dizaine(quotient * 10);
                    else if (reste === 1) numberToLetter = Dizaine(quotient * 10) + "-et-" + Unite(reste);
                    else numberToLetter = Dizaine(quotient * 10) + "-" + Unite(reste);
                } else {
                    numberToLetter = Dizaine((quotient - 1) * 10) + "-" + Dizaine(10 + reste);
                }
            } else {
                numberToLetter = Dizaine(nb);
            }
            break;

        case 3:
            quotient = Math.floor(nb / 100);
            reste = nb % 100;
            if (quotient === 1 && reste === 0) numberToLetter = "cent";
            else if (quotient === 1) numberToLetter = "cent " + NumberToLetter(reste);
            else if (quotient > 1 && reste === 0) numberToLetter = Unite(quotient) + " cents";
            else if (quotient > 1) numberToLetter = Unite(quotient) + " cent " + NumberToLetter(reste);
            break;

        case 4:
        case 5:
        case 6:
            quotient = Math.floor(nb / 1000);
            reste = nb % 1000;
            if (quotient === 1 && reste === 0) numberToLetter = "mille";
            else if (quotient === 1) numberToLetter = "mille " + NumberToLetter(reste);
            else if (reste === 0) numberToLetter = NumberToLetter(quotient) + " mille";
            else numberToLetter = NumberToLetter(quotient) + " mille " + NumberToLetter(reste);
            break;

        case 7:
        case 8:
        case 9:
            quotient = Math.floor(nb / 1000000);
            reste = nb % 1000000;
            if (quotient === 1 && reste === 0) numberToLetter = "un million";
            else if (quotient === 1) numberToLetter = "un million " + NumberToLetter(reste);
            else if (reste === 0) numberToLetter = NumberToLetter(quotient) + " millions";
            else numberToLetter = NumberToLetter(quotient) + " millions " + NumberToLetter(reste);
            break;

        case 10:
        case 11:
        case 12:
            quotient = Math.floor(nb / 1000000000);
            reste = nb % 1000000000;
            if (quotient === 1 && reste === 0) numberToLetter = "un milliard";
            else if (quotient === 1) numberToLetter = "un milliard " + NumberToLetter(reste);
            else if (reste === 0) numberToLetter = NumberToLetter(quotient) + " milliards";
            else numberToLetter = NumberToLetter(quotient) + " milliards " + NumberToLetter(reste);
            break;

        case 13:
        case 14:
        case 15:
            quotient = Math.floor(nb / 1000000000000);
            reste = nb % 1000000000000;
            if (quotient === 1 && reste === 0) numberToLetter = "un billion";
            else if (quotient === 1) numberToLetter = "un billion " + NumberToLetter(reste);
            else if (reste === 0) numberToLetter = NumberToLetter(quotient) + " billions";
            else numberToLetter = NumberToLetter(quotient) + " billions " + NumberToLetter(reste);
            break;
    }

    // Accord pour "quatre-vingts"
    if (numberToLetter.endsWith("quatre-vingt"))
        numberToLetter += "s";

    return numberToLetter;
}

function MoneyToLetter(nombre, devise) {
    const parts = `${nombre}`.split(".");
    const integerpart = parseInt(parts[0], 10);
    const integerPartString = NumberToLetter(integerpart);

    let virgulepartString = "";

    if (parts.length > 1) {
        let virgulepart = parseInt(parts[1], 10);

        if (virgulepart > 0 && virgulepart < 10) {
            virgulepart = virgulepart * 10; 
        }

        virgulepart = Math.round(virgulepart * 100) / 100;
        virgulepartString = NumberToLetter(virgulepart);
    }

    return `${integerPartString} ${devise}${integerpart > 1 ? "s" : ""}${virgulepartString ? ` et ${virgulepartString} centimes` : ""}`;
}

exports.MoneyToLetter = MoneyToLetter;
exports.NumberToLetter = NumberToLetter;
exports.Dizaine = Dizaine;
exports.Unite = Unite;
